"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _useUtils = require("../../_helpers/use-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./SearchBar.css");

var _styles = {
  "searchbar-container": "SearchBar__searchbar-container___I1zw8",
  "text-field-container": "SearchBar__text-field-container___2wop4",
  "search-icon": "SearchBar__search-icon___2wVT0",
  "x-icon": "SearchBar__x-icon___Yjges",
  "text-field": "SearchBar__text-field___2Cak1",
  "show-search-icon": "SearchBar__show-search-icon___VR7QA",
  "arrow-icon": "SearchBar__arrow-icon___3bd3p",
  "ref": "SearchBar__ref___TxoZr",
  "fade_in": "SearchBar__fade_in___1wiGc",
  "has-label": "SearchBar__has-label___1yzRu",
  "disabled": "SearchBar__disabled___1xWFf",
  "item-active": "SearchBar__item-active___2USOj",
  "default-selected": "SearchBar__default-selected___2Blrg"
};

const styles = _bind.default.bind(_styles);

const DEFAULT_AUTO_SUGGEST_LIST = [];
const SearchBar = (0, _mobxReact.observer)(({
  className,
  name = 'dropdown',
  placeholder,
  small,
  autoSuggestList = DEFAULT_AUTO_SUGGEST_LIST,
  helperText,
  value,
  onInputChange,
  onEnter,
  searchCleared,
  dataTestId,
  onDropdownSelect,
  hideSearchIcon,
  hideXIcon,
  hideChevron,
  clearInputAfterSelection
}) => {
  const [inputValue, setInputValue] = (0, _react.useState)(value || '');
  const [hasInputValue, setHasInputValue] = (0, _react.useState)(false);
  const [showSuggestions, setShowSuggestions] = (0, _react.useState)(false);
  const [suggestionsList, setSuggestionsList] = (0, _react.useState)([]);
  const [preferredSuggestionList, setPreferredSuggestionList] = (0, _react.useState)([]);
  const [activeSelection, setActiveSelection] = (0, _react.useState)(null);
  const searchBarRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    setPreferredSuggestionList(suggestionsList.length > 0 ? suggestionsList.slice(0) : autoSuggestList.slice(0));
  }, [suggestionsList, autoSuggestList]);
  (0, _useUtils.useDocumentEvent)('mousedown', event => {
    if (searchBarRef.current && !searchBarRef.current.contains(event.target)) {
      setShowSuggestions(false);
    } else if (!hideChevron || hasInputValue) {
      setShowSuggestions(true);
    }
  });
  (0, _react.useEffect)(() => {
    if (activeSelection !== null) {
      setInputValue(preferredSuggestionList[activeSelection]);
      onInputChange(preferredSuggestionList[activeSelection]);
    }
  }, [activeSelection]);
  (0, _react.useEffect)(() => {
    setInputValue(value || '');
  }, [value]);
  (0, _react.useEffect)(() => {
    const hasValue = typeof inputValue === 'string' && inputValue.trim().length > 0;
    setHasInputValue(hasValue);

    if (!hasValue) {
      setSuggestionsList([]);
    }
  }, [inputValue]);

  const onDropdownChange = e => {
    const user_input = e.currentTarget.value;
    onInputChange(user_input);
    const filterSuggestions = autoSuggestList.filter(suggestion => {
      return suggestion.toLowerCase().includes(user_input.toLowerCase());
    });

    if (autoSuggestList.length > 0 && filterSuggestions.length === 0 && user_input !== '') {
      filterSuggestions.push(user_input);
    }

    if (user_input.length === 0) {
      setActiveSelection(0);
      setShowSuggestions(false);
    } else if (user_input.length > 0) {
      setShowSuggestions(filterSuggestions.length > 0);
    }

    setActiveSelection(null);
    setSuggestionsList(filterSuggestions);
    setInputValue(user_input);
  };

  const selectionClick = i => {
    const selected = preferredSuggestionList[i];
    setSuggestionsList([]);
    setShowSuggestions(false);
    onInputChange(selected);

    if (clearInputAfterSelection) {
      setInputValue('');
    } else {
      setInputValue(selected);
    }

    if (onDropdownSelect) {
      onDropdownSelect(selected);
    }
  };

  const optionRefs = (0, _react.useRef)({});

  const scrollIntoViewOnKeyDown = el => {
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }
  };

  const onKeyDown = e => {
    if (e.keyCode === 8) {
      setShowSuggestions(false);
    } else if (e.keyCode === 13) {
      setShowSuggestions(false);

      if (clearInputAfterSelection) {
        setInputValue('');
      } else {
        setInputValue(e.target.value);
      }

      if (onEnter) {
        onEnter();
      }
    } else if (e.keyCode === 38) {
      if (activeSelection !== 0) {
        const nextSelection = activeSelection === null ? 0 : activeSelection - 1;
        setActiveSelection(nextSelection);
        scrollIntoViewOnKeyDown(optionRefs.current[nextSelection]);
      }
    } else if (e.keyCode === 40) {
      setShowSuggestions(true);

      if (activeSelection !== suggestionsList.length - 1) {
        const nextSelection = activeSelection === null || activeSelection > preferredSuggestionList.length - 2 ? 0 : activeSelection + 1;
        setActiveSelection(nextSelection);
        scrollIntoViewOnKeyDown(optionRefs.current[nextSelection]);
      }
    }
  };

  const composed_classname = (0, _bind.default)(styles('searchbar-container'), className);
  const textfield_classname = (0, _bind.default)(styles('text-field', {
    'show-search-icon': !hideSearchIcon
  }));
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId
  }, _react.default.createElement("div", {
    className: styles('ref'),
    ref: searchBarRef
  }, _react.default.createElement("div", {
    className: styles('text-field-container')
  }, !hideSearchIcon && _react.default.createElement(_.Icon, {
    className: styles('search-icon'),
    name: _.IconEnum.search,
    size: 24,
    color: _.Color.neutral._60
  }), _react.default.createElement(_.TextField, {
    className: textfield_classname,
    name: name,
    helperText: helperText,
    placeholder: placeholder,
    value: inputValue,
    small: small,
    onChange: e => onDropdownChange(e),
    onKeyDown: onKeyDown,
    disableBrowserAutofill: true,
    dataTestId: dataTestId && `${dataTestId}-input`
  }), hasInputValue && !hideXIcon && _react.default.createElement(_.Icon, {
    className: styles('x-icon'),
    name: _.IconEnum.x_mark,
    size: 24,
    color: _.Color.neutral._80,
    onClick: () => {
      setInputValue('');
      onInputChange('');
      setShowSuggestions(false);

      if (searchCleared) {
        searchCleared();
      }
    },
    dataTestId: dataTestId ? `${dataTestId}-x-icon` : undefined
  }), !hasInputValue && !hideChevron && _react.default.createElement("span", {
    "data-testid": dataTestId && `${dataTestId}-chevron`,
    className: styles('arrow-icon'),
    onClick: () => {
      setShowSuggestions(true);
    }
  })), showSuggestions && preferredSuggestionList.length > 0 && _react.default.createElement("ul", {
    id: 'dropdown-list'
  }, preferredSuggestionList.map((item, i) => {
    return _react.default.createElement("li", {
      className: (0, _bind.default)(styles(`item-${activeSelection === i && 'active'}`)),
      key: `${i}-${item}`,
      ref: element => optionRefs.current[i] = element,
      onClick: () => selectionClick(i),
      "data-testid": `${dataTestId}-item-${i}`
    }, _react.default.createElement(_.Text, {
      tag: 'span'
    }, item));
  }))));
});
var _default = SearchBar;
exports.default = _default;